import React, { Component } from 'react'
import { Button, Header, Modal, Form, Icon } from 'semantic-ui-react'

import _ from 'lodash'

class Search extends Component {
  state = {
    merchant: null,
    customer: null,
    driver: null,
    searching: false,
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  onSearchClick = () => this.btnSubmitRef.click()

  onSearchPress = () => {
    const { orders, onSearchSuccess } = this.props
    const { merchant, customer, driver } = this.state

    if (!merchant && !customer && !driver) {
      // eslint-disable-next-line no-alert
      return alert('Please choose one option to filter')
    }

    this.setState({ searching: true })

    const filteredOrder = []

    for (let index = 0; index < orders.length; index += 1) {
      const order = orders[index]
      let shouldAdd = true

      if (merchant && merchant !== order.restaurant.key) {
        shouldAdd = false
      }

      if (customer && customer !== order.deliveree) {
        shouldAdd = false
      }

      if (driver && driver !== order.deliverer) {
        shouldAdd = false
      }

      if (shouldAdd) {
        filteredOrder.push(order)
      }
    }

    this.setState({ searching: false })

    return onSearchSuccess(filteredOrder)
  }

  clearFilter = () => {
    this.setState({
      merchant: null,
      customer: null,
      driver: null,
    })
  }

  getSelectOptions = () => {
    const { orders, drivers } = this.props

    const merchantOptions = {}
    const driverOptions = {}
    const customerOptions = {}

    for (let i = 0; i < orders.length; i+=1) {
      const {
        deliveree,
        deliveree_name: delivereeName,
        deliverer,
        tel,
        restaurant,
      } = orders[i]

      const driver = drivers[deliverer]
      const merchantKey = restaurant.key

      customerOptions[deliveree] = {
        key: deliveree,
        value: deliveree,
        text: `${delivereeName} (${tel})`
      }
      merchantOptions[merchantKey] = {
        key: merchantKey,
        value: merchantKey,
        text: restaurant.name
      }

      if (deliverer && driver) {
        driverOptions[deliverer] = {
          key: deliverer,
          value: deliverer,
          text: `${driver.family_name} ${driver.first_name} (${deliverer})`
        }
      }
    }

    return {
      merchants: Object.values(merchantOptions),
      drivers: Object.values(driverOptions),
      customers: Object.values(customerOptions)
    }
  }

  renderSearchField = (field, options) => (
    <Form.Group widths='equal' style={{ marginBottom: 15 }}>
      <Form.Dropdown
        fluid
        search
        clearable
        selection
        options={options}
        label={_.capitalize(field)}
        placeholder={`Please choose ${field}`}
        onChange={(e, data) => this.setState({ [field]: data.value })}
        // eslint-disable-next-line react/destructuring-assignment
        value={this.state[field]}
      />
    </Form.Group>
  )

  renderTriggerButton = () => (
    <Button animated='vertical' onClick={this.handleOpen} floated='right'>
      <Button.Content hidden>Search</Button.Content>
      <Button.Content visible>
        <Icon name='search' />
      </Button.Content>
    </Button>
  )

  render() {
    const { modalOpen, searching } = this.state
    const selectOptions = this.getSelectOptions()

    return (
      <Modal
        size='small'
        open={modalOpen}
        onClose={this.handleClose}
        trigger={this.renderTriggerButton()}
      >
        <Header content='Search Orders' />
        <Modal.Content>
          <Form onSubmit={this.onSearchPress} disabled={searching}>

            {this.renderSearchField('driver', selectOptions.drivers)}
            {this.renderSearchField('customer', selectOptions.customers)}
            {this.renderSearchField('merchant', selectOptions.merchants)}

            <button
              hidden
              type="submit"
              ref={ref => { this.btnSubmitRef = ref }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button floated="left" onClick={this.clearFilter} disabled={searching}>
            Clear Filter
          </Button>
          <Button onClick={this.handleClose} disabled={searching}>
            Close
          </Button>
          <Button
            icon
            color="black"
            loading={searching}
            disabled={searching}
            onClick={this.onSearchClick}
          >
            <Icon name="search" /> Search
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/containers/orders/components/Search.js